export default __webpack_public_path__ + "static/media/d26ae395bf933376ff60a390fa0b5a9c.svg";